import script from "./SetMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./SetMultiple.vue?vue&type=script&setup=true&lang=js"

import "./SetMultiple.vue?vue&type=style&index=0&id=2bc432ea&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc432ea"]])

export default __exports__